import React from 'react';
import type { TInfoUpdate } from '../../types/TBatchUpdate';

const UpdateInfoContext = React.createContext<TInfoUpdate>({} as TInfoUpdate);

export default UpdateInfoContext;
